<template>
  <div v-if="isLoading">
    <LoadingAnimation />
  </div>
  <div
    class="text-center d-flex align-items-center mx-4 display-4"
    style="min-height: 500px"
    v-else-if="error"
  >
    <axiosError></axiosError>
  </div>

  <div
    v-else
    :class="{
      'main-side-by-side': sideBySide,
      row: allGroupsHaveOneProduct,
      'one-per-group': allGroupsHaveOneProduct,
    }"
  >
    <div class="col-12 mt-4" v-if="allGroupsHaveOneProduct">
      <div
        v-if="
          productGroups[0].banner?.desktopBannerBackground?.url?.trim() ||
          productGroups[0].banner?.desktopHeroBannerLogo?.url?.trim()
        "
        class="upt-intro"
        :class="[
          productGroups[0].banner.bannerAlignment,
          'theme-' + uptGlobal?.globalOptions?.highlightTextColor,
        ]"
      >
        <div class="content">
          <div class="row">
            <div class="col">
              <img
                v-if="productGroups[0].banner?.mobileHeroBannerLogo"
                :src="productGroups[0].banner?.mobileHeroBannerLogo?.url"
                :style="{
                  width: productGroups[0].banner?.mobileLogoWidth + 'px',
                }"
                class="img-fluid mobile-only"
              />
              <img
                v-if="productGroups[0].banner?.desktopHeroBannerLogo"
                :src="productGroups[0].banner?.desktopHeroBannerLogo?.url"
                :style="{
                  width: productGroups[0].banner?.desktopLogoWidth + 'px',
                }"
                class="img-fluid"
                :class="{
                  'hidden-mobile':
                    productGroups[0].banner?.mobileHeroBannerLogo,
                }"
              />
              <h1 :class="productGroups[0].banner.bannerHeader.fontStyle">
                {{ productGroups[0].banner.bannerHeader.content }}
              </h1>
              <h4 :class="productGroups[0].banner.bannerSubheader.fontStyle">
                {{ productGroups[0].banner.bannerSubheader.content }}
              </h4>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- Mobile image if available -->
        <div
          class="media"
          :style="{
            'background-color': uptGlobal?.globalOptions?.highlightColor,
          }"
        >
          <img
            v-if="productGroups[0].banner?.mobileBannerBackground?.url?.trim()"
            :src="productGroups[0].banner.mobileBannerBackground.url"
            alt="allpa bundle"
            class="img-fluid mobile-only"
          />
          <!-- Fallback to desktop image if mobile is missing -->
          <img
            v-if="productGroups[0].banner?.desktopBannerBackground?.url?.trim()"
            :src="productGroups[0].banner.desktopBannerBackground.url"
            class="img-fluid hidden-mobile"
          />
        </div>
        <!-- .media -->
      </div>
      <!-- upt-intro -->

      <div v-else>
        <h1 class="display-1 mb-0">
          {{ productGroups[0].banner.bannerHeader.content }}
        </h1>
        <h4 :class="productGroups[0].banner.bannerSubheader.fontStyle">
          {{ productGroups[0].banner.bannerSubheader.content }}
        </h4>
      </div>

      <div
        class="row"
        v-if="
          uptGlobal?.disclaimerModal?.disclaimerModalActive &&
          allGroupsHaveOneProduct
        "
      >
        <div class="col">
          <p>{{ uptGlobal.disclaimerModal.body }}</p>
          <!-- <button class="disclaimer-link" style="padding-top:0;" @click="showDiscModal = true">
              Click here for Details +
            </button> -->
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
    </div>
    <!-- .col-12 -->
    <div
      v-for="(group, index) in productGroups"
      :key="group.id || index"
      :class="[{ 'col-6 col-lg-4 one-prod-col': allGroupsHaveOneProduct }]"
    >
      <div
        v-if="
          group?.banner?.bannerHeader.content?.trim() ||
          group?.banner?.desktopBannerBackground?.url?.trim() ||
          group?.banner?.desktopHeroBannerLogo?.url?.trim()
        "
        class="upt-intro"
        :class="[
          group.banner.bannerAlignment,
          'theme-' + uptGlobal?.globalOptions?.highlightTextColor,
        ]"
      >
        <div class="content">
          <div class="row">
            <div class="col">
              <img
                v-if="group?.banner?.mobileHeroBannerLogo"
                :src="group?.banner?.mobileHeroBannerLogo?.url"
                :style="{ width: group?.banner?.mobileLogoWidth + 'px' }"
                class="img-fluid mobile-only"
              />
              <img
                v-if="group?.banner?.desktopHeroBannerLogo"
                :src="group?.banner?.desktopHeroBannerLogo?.url"
                :style="{ width: group?.banner?.desktopLogoWidth + 'px' }"
                class="img-fluid"
                :class="{
                  'hidden-mobile': group?.banner?.mobileHeroBannerLogo,
                }"
              />
              <h1 :class="group.banner.bannerHeader.fontStyle">
                {{ group.banner.bannerHeader.content }}
              </h1>
              <h4 :class="group.banner.bannerSubheader.fontStyle">
                {{ group.banner.bannerSubheader.content }}
              </h4>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- Mobile image if available -->
        <div
          class="media"
          :style="{
            'background-color': uptGlobal?.globalOptions?.highlightColor,
          }"
        >
          <img
            v-if="group?.banner?.mobileBannerBackground?.url?.trim()"
            :src="group.banner.mobileBannerBackground.url"
            alt="allpa bundle"
            class="img-fluid mobile-only"
          />
          <!-- Fallback to desktop image if mobile is missing -->
          <img
            v-if="group?.banner?.desktopBannerBackground?.url?.trim()"
            :src="group.banner.desktopBannerBackground.url"
            class="img-fluid hidden-mobile"
          />
        </div>
        <!-- .media -->
      </div>
      <!-- upt-intro -->
      <div
        class="container-fluid"
        v-if="
          index === 0 &&
          uptGlobal?.disclaimerModal?.disclaimerModalActive &&
          !allGroupsHaveOneProduct
        "
      >
        <div class="row">
          <div class="col text-right">
            <button class="disclaimer-link" @click="showDiscModal = true">
              Disclaimer +
            </button>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <!-- .container-fluid -->
      <div
        :id="'group-' + index"
        style="
          width: 10px;
          height: 10px;
          opacity: 0;
          display: block;
          position: relative;
        "
      ></div>
      <div class="container-fluid" v-if="group.instructions?.showInstructions">
        <div class="row">
          <div class="col text-center mt-5 mb-2">
            <h1 class="display-4">{{ group.instructions.title }}</h1>
            <h5 class="display-6">{{ group.instructions.subtitle }}</h5>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <!-- .container-fluid -->

      <div v-if="group.quickLinks?.showQuickLinks" class="container-fluid">
        <div class="row">
          <div class="col quick-nav">
            <div class="links-inner">
              <ul>
                <li
                  v-for="(qlink, qlinkIndex) in group.quickLinks.links"
                  class="nav-item"
                >
                  <a
                    class="quick-nav-link"
                    :href="getQuicklinkUrl(index, qlinkIndex)"
                    >{{ qlink.title }}</a
                  >
                </li>
              </ul>
            </div>
            <!-- .links-inner -->
          </div>
          <!-- .quick-nav -->
        </div>
        <!-- .row -->
      </div>
      <!-- .container-fluid -->

      <uptCollectionGrid
        :class="{ 'single-product-per-group': allGroupsHaveOneProduct }"
        :allGroupsHaveOneProduct="allGroupsHaveOneProduct"
        :collectionId="collectionId"
        :group="group"
        :groupNumber="index"
        :groupDiscountType="group.discountBy"
        :groupTiers="group.tiers"
        :heroBackground="uptGlobal?.globalOptions?.highlightColor"
        :showFilters="sectiondata.showFilters"
        :sideBySide="sideBySide"
        :colorwaySort="colorwaySort"
        :bundleBuilder="bundleBuilder"
        @add-to-bundle="addProductToBundle"
      />
    </div>
  </div>

  <div
    class="upt-always-on-bundle-widget"
    :class="[
      {
        closed: uptDrawerClosed && !sideBySide,
        closedSide: uptDrawerClosed,
        'widget-side-by-side': sideBySide,
        'weird-scroll-window': isInScrollRange,
      },
      'theme-' + uptGlobal?.globalOptions?.highlightTextColor,
    ]"
    :style="{ 'background-color': uptGlobal?.globalOptions?.highlightColor }"
  >
    <div class="builder-title">
      <h2>In Your Bundle</h2>
      <p v-if="bundleReqsMet">
        <strong>You did it!</strong> You qualify for this promotion!
      </p>
      <p v-else>Add more items to qualify for the discount.</p>
    </div>
    <!-- .builder-title -->
    <div class="builder-add">
      <button
        v-if="bundleReqsMet === false"
        @click="showDiscModal = true"
        class="btn btn-outline mt-2"
        style="opacity: 0.35"
      >
        Add Bundle to Cart
      </button>
      <button v-else @click="addBundleToCart()" class="btn btn-black">
        Add Bundle to Cart
      </button>
    </div>
    <!-- .builder-add -->
    <div class="builder">
      <div
        class="builder-tile"
        :class="{
          parent: bundleItem.class === 'plus',
          empty: bundleItem.status === 'empty',
        }"
        v-for="bundleItem in bundleBuilder"
      >
        <div class="image-box">
          <img :src="bundleItem.image" class="img-fluid" />
        </div>
        <!-- .img-box -->
        <div class="name">{{ bundleItem.productName }}</div>
        <!-- .name -->
        <div class="size">
          {{ bundleItem.size != 'null' ? bundleItem.size : '' }}
        </div>
        <!-- .size -->
        <button @click="deleteBundleItem(bundleItem)" class="trash">
          <span class="lid"></span>
          <span class="can"></span>
        </button>
        <span class="add" @click="uptDrawerClosed = !uptDrawerClosed"></span>
      </div>
      <!-- .builder-tile -->
    </div>
    <!-- builder -->

    <div class="builder-toggler">
      <span class="minimize" @click="uptDrawerClosed = !uptDrawerClosed"
        >Minimize</span
      >
      <span class="maximize" @click="uptDrawerClosed = !uptDrawerClosed"
        >Open to Edit</span
      >
    </div>
    <!-- .builder-toggler -->

    <div class="builder-keep-going">
      <button
        v-if="!bundleReqsMet"
        @click="uptDrawerClosed = !uptDrawerClosed"
        class="btn btn-link btn-white"
      >
        Keep Adding
      </button>
    </div>
    <!-- .builder-keep-going -->
  </div>
  <!-- upt-always-on-bundle-widget -->

  <!-- ==================== Disclaimer MODAL ==================== -->
  <div
    class="ctpx-disclaimer-modal"
    v-if="uptGlobal?.disclaimerModal?.disclaimerModalActive"
    v-show="showDiscModal"
  >
    <div class="ctpx-modal-content">
      <div class="ctpx-modal-close" @click="showDiscModal = false">X</div>
      <!-- .ctpx-modal-close -->
      <h3 class="disc-title">{{ uptGlobal.disclaimerModal.title }}</h3>
      <p>{{ uptGlobal.disclaimerModal.body }}</p>
      <!-- <a :href="uptGlobal.disclaimerLink" class="btn btn-black">{{uptGlobal.disclaimerCTA}}</a> -->
    </div>
    <!-- .ctpx-modal-content -->
  </div>
  <!-- ctpx-product-modal -->
  <div
    class="ctpx-modal-backdrop"
    v-show="showDiscModal"
    @click="showDiscModal = false"
  ></div>
  <!-- .ctpx-disclaimer-backdrop -->

  <!-- ==================== Over Max Products Modal MODAL ==================== -->
  <div class="ctpx-disclaimer-modal" v-show="showMaxMetModal">
    <div class="ctpx-modal-content">
      <div class="ctpx-modal-close" @click="showMaxMetModal = false">X</div>
      <!-- .ctpx-modal-close -->
      <h3 class="disc-title">
        {{
          uptGlobal?.bundleFullModal?.title
            ? uptGlobal?.bundleFullModal?.title
            : 'Uh oh! Too Many Items In Your Bundle'
        }}
      </h3>
      <p>
        {{
          uptGlobal?.bundleFullModal?.body
            ? uptGlobal?.bundleFullModal?.body
            : "You've hit the max number of items allowed in a group. Delete a product so you can add a new one to your bundle."
        }}
      </p>
      <!-- <a :href="uptGlobal.disclaimerLink" class="btn btn-black">{{uptGlobal.disclaimerCTA}}</a> -->
    </div>
    <!-- .ctpx-modal-content -->
  </div>
  <!-- ctpx-product-modal -->
  <div
    class="ctpx-modal-backdrop"
    v-show="showMaxMetModal"
    @click="showMaxMetModal = false"
  ></div>

  <!-- .ctpx-disclaimer-backdrop -->
</template>

<script src="./ctrl-upt-collection-container.js"></script>
